import { ConditionalRender } from '@/features/layouts/components/ConditionalRender';
import type { BoxProps } from '@/ui';
import { BannerRead } from './Banner.read';
import { BannerWrite } from './Banner.write';

export type BannerProps = {
  height?: string | number;
  borderRadius?: BoxProps['borderRadius'];
};

export const Banner = ({ height, borderRadius }: BannerProps) => {
  return (
    <ConditionalRender
      read={<BannerRead borderRadius={borderRadius} height={height} />}
      write={<BannerWrite borderRadius={borderRadius} height={height} />}
    />
  );
};
